import * as React from 'react';
import { ThemeProvider } from '@websky/core/src/theme';
import theme from '../../theme/theme';
import Head from '@websky/core/src/Head';
import { Forms } from '@websky/core';
import { RenderersProvider } from '@websky/core/src/renderProps';
import { renders as renderProps } from '../../renders';
import '../../theme/variables.css';
const SearchFormComponent = () => {
    return (React.createElement(ThemeProvider, { value: theme },
        React.createElement(RenderersProvider, { value: renderProps },
            React.createElement(Head, null),
            React.createElement(Forms, null))));
};
export default SearchFormComponent;
